<template>
  <div>
    <advertising-series
      :condition="condition"
      :loading="loading"
      :customTitle="customTitle"
    ></advertising-series>
  </div>
</template>

<script>
import advertisingSeries from '@/components/client/clientCharts/advertising-series'
export default {
  props: ['tableData', 'scope'],
  data() {
    return {
      condition: {
        data: [],
        extend: {
          xAxis: {
            axisLabel: {
              formatter(val) {
                return val
              }
            }
          }
        }
      },
      loading: false,
      customTitle: '这个词在所选时间段内的搜索及广告触发情况'
    }
  },
  mounted() {
    this.getListChartsData()
  },
  methods: {
    async getListChartsData() {
      this.loading = true
      try {
        let data = await this.tableData.getListChartsData(this.scope.row)

        this.condition.data = data
        this.loading = false
      } catch (error) {
        this.$message.info('图表数据请求失败')
        this.condition.data = []
        this.loading = false
      }
    }
  },
  components: { advertisingSeries }
}
</script>

<style>
</style>
